import { Card, CardContent } from '@design-system';
import { consumerQuoteCarrier, type ConsumerQuote } from '@shared/consumerPlan';
import { getCarrierLogoSrc } from '@/util/carrierLogo';
import { premiumText } from '../lib/format';

export function SelectedCoverageSummary({ quote }: { quote: ConsumerQuote }) {
  const carrier = consumerQuoteCarrier(quote);

  return (
    <Card className="py-4">
      <CardContent className="flex items-center gap-3 px-4">
        <img src={getCarrierLogoSrc(carrier)} alt="" className="h-8 max-w-24 object-contain" />
        <div className="flex flex-col">
          <strong className="text-gray-950">
            {carrier} · {quote.productName}
          </strong>
          <span className="text-muted-foreground text-sm">{premiumText(quote)}</span>
        </div>
      </CardContent>
    </Card>
  );
}
